import type { ReactNode } from "react";

type AdminTableFiltersCardProps = {
  children: ReactNode;
};

const AdminTableFiltersCard = ({ children }: AdminTableFiltersCardProps) => {
  return (
    <div className="mb-5 rounded-2xl border border-myteengig-border bg-gradient-to-r from-white via-myteengig-background to-white p-4 shadow-sm sm:p-5">
      {children}
    </div>
  );
};

export default AdminTableFiltersCard;
